import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
	documentWorkflowControllerAddCounterpartyMutation,
	documentWorkflowControllerGetAddCounterpartyEligibilityOptions,
	documentWorkflowControllerGetAddCounterpartyEligibilityQueryKey,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { getDocumentWorkflowEventsQueryKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useDocumentWorkflowEvents';
import { buildInvestmentProgrammeDocumentQueryKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/documentQueryKeys';
import type { AddCounterpartyPanelState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useAddCounterpartyToDocument.types';

export const useAddCounterpartyToDocument = (params: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}): AddCounterpartyPanelState => {
	const queryClient = useQueryClient();
	const { dealId, programmeId, documentWorkflowInstanceId } = params;
	const path = { dealId, programmeId, documentWorkflowInstanceId };

	const eligibility = useQuery(
		documentWorkflowControllerGetAddCounterpartyEligibilityOptions({ path })
	);

	const addCounterparty = useMutation({
		...documentWorkflowControllerAddCounterpartyMutation(),
		onSuccess: async () => {
			// The remaining-slot count, the signers panel and the activity log all move together
			// with the addition.
			await Promise.all([
				queryClient.invalidateQueries({
					queryKey: documentWorkflowControllerGetAddCounterpartyEligibilityQueryKey({
						path,
					}),
				}),
				queryClient.invalidateQueries({
					queryKey: getDocumentWorkflowEventsQueryKey(path),
				}),
				queryClient.invalidateQueries({
					queryKey: buildInvestmentProgrammeDocumentQueryKey(params),
				}),
			]);
		},
	});

	return { eligibility, addCounterparty };
};
